import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import { customReducers } from './reducers';
import { customSagas } from './sagas';

class MiddlewareManager {
  /** @private */
  maps = {
    link: new WeakMap(),
    name: new Map(),
  };
  /** @private */
  middlewares = [];
  /** @private */
  options;
  /** @private */
  sagas = [];

  constructor({ options, sagas }) {
    this.options = options;
    this.sagas = sagas;

    this.init();
  }

  /** @private */
  init() {
    this.sagas.forEach(() => {
      this.middlewares.push(createSagaMiddleware(this.options));
    });
  }

  run() {
    this.sagas.forEach((saga, index) => {
      const task = this.middlewares[index].run(saga);

      this.maps.link.set(saga, task);

      if (saga.name) {
        this.maps.name.set(saga.name, task);
      }
    });
  }

  setContext(saga, props) {
    const { link, name } = this.maps;

    const task = typeof saga === 'string' ? name.get(saga) : link.get(saga);

    if (!task) {
      return;
    }

    task.setContext(props);
  }
}

const composeEnhancers = composeWithDevTools({
  serialize: true,
});

export const middlewareManager = new MiddlewareManager({ sagas: customSagas });

let store = null;

export default function () {
  if (store) {
    return store;
  }

  store = createStore(
    combineReducers(customReducers),
    composeEnhancers(applyMiddleware(...middlewareManager.middlewares))
  );

  middlewareManager.run();

  return store;
}
